<template>
  <aside class="menu elevation-4" v-show="isMenuVisible">
    <div class="menu-logo">
      <img src="@/assets/images/logo-branco.svg" alt="Logo" />
    </div>
    <Tree :data="treeData" :options="treeOptions" ref="tree">
      <label class="tree-text menu-label" slot-scope="{ node }">
        <template>
          <i v-if="node.data.customData.pagina_icon" style="font-size:0.8em" :class="node.data.customData.pagina_icon"></i>
          {{ node.text }}
        </template>
      </label>      
    </Tree>
  </aside>
</template>

<script>
import { mapState } from "vuex";
import Tree from "liquor-tree";
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
  name: "Menu",
  components: { Tree },
  computed: mapState(["isMenuVisible", "user"]),
  data: function() {
    return {
      treeData: this.getTreeData(),
      treeOptions: {
        propertyNames: { text: "pagina_label", data: "customData" }
      }
    };
  },
  methods: {
    getTreeData() {
      if(!this.$store.state.user.user)
        this.$router.push({ path: "/login" });
        
      const url = `${baseApiUrl}/usuarios/${this.$store.state.user.user.email}/menu`;
      return axios.get(url).then(res => {
        for (const iterator of res.data) {
          iterator.customData = iterator;
        }
        let _tree = this.toTree(res.data);
        return _tree;
      }).catch(showError);
    },
    toTree(categories, tree) {
      if (!tree) tree = categories.filter(c => !c.menu_id_pai);

      tree = tree.map(parentNode => {
        const isChild = node => node.menu_id_pai == parentNode.menu_id;
        parentNode.children = this.toTree(
          categories,
          categories.filter(isChild)
        );
        return parentNode;
      });
      return tree;
    },
    onNodeSelect(node) {
      if (node && node.data && node.data.pagina_url.trim() !== "") {
          this.$router.push({path: node.data.pagina_url}).catch(() => {});
      }
      if (node.children.length == 0 && (this.$mq === "xs" || this.$mq === "sm")) {
        this.$store.commit("toggleMenu", false);
      }
    }
  },
  mounted() {
    this.$refs.tree.$on("node:selected", this.onNodeSelect);
  }
};
</script>

<style scoped>
.menu {
  grid-area: menu;
  /*background: linear-gradient(to right, #232526, #414345);*/
  background-color: #343a40;
  z-index: 1034;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  color: #fff !important;
}

.menu-logo {
  height: 57px;
  background-color: #343a40;
  border-bottom: 1px solid #4f5962;
  

  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-logo img {
  height: 50px;
  width: auto;
}

 .menu >>> .tree-node.selected > .tree-content,
.menu >>> .tree-node .tree-content:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: 4px !important;
}

.menu >>> .tree-arrow.has-child {
  filter: brightness(2);
}

.menu >>> .tree-anchor {
  color: #ccc !important;
}

.menu-label {
      flex-grow: 1;
      cursor: pointer;
    }

.menu-tree .tree-anchor.selected {
  background-color: #fff
}

.elevation-4 {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22) !important;
}
</style>
